export default class ChangeElementTextMergeableAction {
    constructor(elementId, text, selectionBefore) {
        this.elementId = elementId;
        this.text = text;
        this.selectionBefore = selectionBefore;
        this.type = 'changeElementTextMergeable';
        this.time = Date.now();
        this.textBefore = null;
        this.selection = null;
    }
    apply(state, dom, logger) {
        if (null === this.selection) {
            this.selection = dom.getSelection(); // taking the selection before changing the text is OK here, as the text has been changed in DOM already
        }
        const idsToEvaluate = this.changeText(state, dom, this.text, logger);
        return {
            idsToEvaluate
        };
    }
    undo(state, dom, logger) {
        const returnValue = { idsToEvaluate: [] };
        if (null !== this.textBefore) {
            returnValue.idsToEvaluate = this.changeText(state, dom, this.textBefore, logger);
        }
        if (this.selectionBefore) {
            dom.setSelection(this.selectionBefore);
        }
        return returnValue;
    }
    getDataToMergeWithNext(nextType) {
        if (nextType === this.type) {
            return {
                time: this.time,
                id: this.elementId,
                textBefore: this.textBefore,
                selectionBefore: this.selectionBefore,
            };
        }
        return {};
    }
    mergeWithPrevious(previousType, previousData) {
        if (previousType !== this.type) {
            return false;
        }
        if (previousData.id === this.elementId && this.time - previousData.time < 2000) {
            this.textBefore = previousData.textBefore;
            this.selectionBefore = previousData.selectionBefore;
            return true;
        }
        return false;
    }
    changeText(state, dom, textToSet, logger) {
        const element = state.elements.getById(this.elementId);
        if (!element) {
            return [];
        }
        if (null === this.textBefore) {
            this.textBefore = element.getText();
        }
        const textUpdateResult = element.updateText(textToSet);
        if (textUpdateResult.renderNeeded || textUpdateResult.textChanged) { // We don't need to sync text as a result of regular character changes, but when we need to re-render for emphasis or change text based on actions like splitting elements.
            element.syncText(dom.getById(element.getId()));
            if (this.selection) {
                dom.setSelection(this.selection);
            }
        }
        if (textUpdateResult.intrinsicTypeAfter !== textUpdateResult.intrinsicTypeBefore) {
            logger.log('Intrinsic type changed for', textToSet, textUpdateResult);
            return [element.getId()];
        }
        return [];
    }
}
